export default __webpack_public_path__ + "static/html-3ed92ed39e2c7f3b15e5d73641682115.png";